export default function SvgIcon({icon, className}:any) {

  return (
    <div style={{ maskImage: `url(${icon})`, WebkitMaskImage: `url(${icon})`, maskPosition: 'center', maskSize: 'cover', maskRepeat: 'no-repeat', WebkitMaskPosition: 'center', WebkitMaskSize: 'cover' }} className={`${className}`}></div>

  )
  
}